(function () {
    'use strict';

    run.parts.tooltips = function() {
        jQuery(document).ready(function() {
            jQuery('body').tooltip({
                selector: '[data-toggle="tooltip"]'
            });
        });
    };
})();